import { InfoCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

interface InfoProps{
  title: string;
}

const Info: React.FunctionComponent<InfoProps> = ({ title }) => {
  return (
    <Tooltip title={title}>
      <InfoCircleFilled />
    </Tooltip>
  );
};

export default Info;
